import React, { useEffect, memo } from 'react';
import { identity, prop } from 'ramda';
import { componentService } from 'js/services/component.service';
import { usePortletSelector, withPortlet } from 'js/components/system/Portlet';
import { dispatcher } from 'dispatcher';
import { getBonuses } from './actions';
import reducer, { initialState } from './reducer';
import style from './index.scss';
import { I18n } from 'js/components/common/I18n';
import { useTableData } from './hooks/useTableData';
import { Table, TABLE_VIEW } from 'js/components/common/Table';

export const PPE_WAGER_SWISS = 'prewagerswiss';

export const fetchPreWager = async () => {
    const balances = await getBalances();

    if (!balances.data?.bonuses) {
        return [];
    }

    const activeBonuses = balances.data.bonuses.filter(el => el.status === 2 || el.status === 3);
    const preWagerTemplates = balances.data.bonusTemplates.filter(el => el.playType === 'prewager');
    const preWagers = activeBonuses.filter(el => preWagerTemplates.map(item => item.code).includes(el.templateCode));

    return preWagers.reduce((target, key, index) => {
        const bonusTemplate = balances.data.bonusTemplates.filter(el => el.code === key.templateCode)?.[0];
        target[index] = {
            bonusTemplate,
            balance: key
        };

        return target;
    }, []);
};

export const getBalances = async () => {
    const fromDate = new Date();
    const toDate = new Date(fromDate);
    fromDate.setFullYear(fromDate.getFullYear() - 10);

    return await getBonuses(fromDate, toDate);
};

export const parseError = () => `playtech.mobile.system.${PPE_WAGER_SWISS}.error`;

export const PreWagerBalancesBare = memo((props) => {
    const { fetchPortlet, error, isLoading } = props;

    const preWagerBalances = usePortletSelector(prop('preWagerBalances')) || [];

    const currentData = useTableData(preWagerBalances, fetchPortlet);

    useEffect(() => {
        dispatcher.listen('preWagerBalances:fetch', fetchPortlet);

        return () => {
            dispatcher.removeListener('preWagerBalances:fetch', fetchPortlet);
        };
    }, [fetchPortlet]);

    if (preWagerBalances.length === 0) {
        return <span className={style.error}>
            <I18n tKey={'playtech.mobile.system.preWager.no-bonus'}/>
        </span>;
    }

    return (
        <div className={`${style.list} cms-pre-wager-swiss`}>
            <Table
                error={error}
                classNames={style}
                isLoading={isLoading}
                tableData={currentData}
                tableRowView={TABLE_VIEW.ACCORDION}
            />
        </div>
    );
});

export const PreWagerSwiss = withPortlet({
    forLoggedIn: true,
    fetch: fetchPreWager,
    onResponse: identity,
    onError: parseError,
    reducer,
    initialState
})(PreWagerBalancesBare);

componentService.registerPageComponents({ [PPE_WAGER_SWISS]: PreWagerSwiss });
